import language from './phrases/language';
import noExplanations from './phrases/noExplanations';
export default {
    language,
    noExplanations,
};
//# sourceMappingURL=index.js.map